export default "__VITE_ASSET__52840401__"